import type { ValueOf } from './utility';

export const SORT_ORDER = {
  Asc: 'asc',
  Desc: 'desc',
} as const;

export type SortOrder = ValueOf<typeof SORT_ORDER>;
